import { authorizedRequest } from 'videoReview/api'
import { Cue } from 'videoReview/utils/parseVtt'

export type PublishSubtitlesProps = {
  id: string
  lang: string
  cues: Cue[]
}

export type PublishSubtitlesResults = {
  success: boolean
  id?: string
  lang?: string
  error?: string
}

export const publishSubtitles = async ({
  id,
  lang,
  cues,
}: PublishSubtitlesProps): Promise<PublishSubtitlesResults> => {
  const response = await authorizedRequest({
    endpoint: `v1/media/subtitle/publish/${id}`,
    method: 'POST',
    body: { lang, cues },
  })
  return (await response.json()) as PublishSubtitlesResults
}
